import { type WorkspaceAgentActionsMenuTask } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentActionsMenuTasks';

/** Case-insensitive substring match on each task's label and keywords. A blank query keeps every task. */
export const filterWorkspaceAgentActionsMenuTasks = (
  tasks: readonly WorkspaceAgentActionsMenuTask[],
  query: string,
): readonly WorkspaceAgentActionsMenuTask[] => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return tasks;
  }

  return tasks.filter(
    (task) =>
      task.label.toLowerCase().includes(normalizedQuery) ||
      task.keywords.some((keyword) => keyword.toLowerCase().includes(normalizedQuery)),
  );
};
